import React from 'react';
import cn from 'classnames';
import Message from 'components/common/Message';

import style from './BottomMessage.module.scss';
import Button, {ButtonStyles} from 'components/common/Form/Button';

export default function BottomMessage({text, linkText, linkTo, className}) {
    return (
        <div className={cn(style.bottomMessageContainer, className)}>
            <Message className={style.firstMessage}>{text}</Message>
            <div className={style.spacer} />
            <Message className={style.secondMessage}>
                <Button text={linkText} href={linkTo} className={style.button} btnStyle={ButtonStyles.secondary} />
            </Message>
        </div>
    );
}
